import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { SegmentDto } from '@/modules/counterparty/dto/segment.dto.ts';
import type { Segment } from '@/modules/counterparty/types/segment.type.ts';

export class SegmentAdapter {
  private static map(response: SegmentDto): Segment {
    return {
      id: Number(response.SEGMENT_ID),
      name: response.Название,
      note: response.Примечание,
    };
  }

  static mapList(response: ItemsDto<SegmentDto>) {
    return response.items.map(SegmentAdapter.map);
  }
}
